import(/* webpackMode: "eager" */ "/home/runner/work/rstu-connect/rstu-connect/src/app/page.tsx");
